import { render, staticRenderFns } from "./MyBargain.vue?vue&type=template&id=5d56dca2&scoped=true"
import script from "./MyBargain.vue?vue&type=script&lang=js"
export * from "./MyBargain.vue?vue&type=script&lang=js"
import style0 from "./MyBargain.vue?vue&type=style&index=0&id=5d56dca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d56dca2",
  null
  
)

export default component.exports